
import axios from "axios";
import { Payout_Service } from "../Url";


export const MiscellaneousAction = {
    MISCELLANEOUS_LIST_SUCCESS: "MISCELLANEOUS_LIST_SUCCESS",
    MISCELLANEOUS_LIST_ERROR: "MISCELLANEOUS_LIST_ERROR",
    GENERATE_MISCELLANEOUS_SUCCESS: "GENERATE_MISCELLANEOUS_SUCCESS",
    GENERATE_MISCELLANEOUS_ERROR: "GENERATE_MISCELLANEOUS_ERROR",
};



export function miscellaneousListSuccess(props) {
  const { accessToken, partnerId, reportId } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "POST",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        url: `${Payout_Service}/reports/get/partner-misc-adjustment?partnerId=${partnerId}&reportId=${reportId}`,
      });

      console.log("Miscellaneous List Data:", response);
      const data = response.data;
    //   dispatch({
    //     type: MiscellaneousAction.MISCELLANEOUS_LIST_SUCCESS,
    //     payload: data.data,
    //   });
      console.log("Miscellaneous List Data:", data.data);
      return data.data;
    } catch (error) {
      console.error("Error:", error);
    //   dispatch({
    //     type: MiscellaneousAction.MISCELLANEOUS_LIST_ERROR,
    //     payload: error.message || "Failed to fetch miscellaneous list data",
    //   });
      return error;
    }
  };
}

export function generateMiscellaneousAction(props) {
  const { accessToken, Data, } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "POST",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        url: `${Payout_Service}/reports/add/partner-misc-adjustment`,
        data: Data,
      });
      const data = response.data;
      console.log("Generate Miscellaneous Data:", data);

      // Refresh miscellaneous list after generating report
    //   await dispatch(
    //     miscellaneousListSuccess({ accessToken, financialYear })
    //   );

      return response;
    } catch (error) {
      console.error("Error:", error);
      // dispatch({
      //   type: MiscellaneousAction.GENERATE_MISCELLANEOUS_ERROR,
      //   payload: error.message || "Failed to generate miscellaneous report",
      // });
      return error;
    }
  };
}

export function removeMiscellaneousAction(props) {
  const { accessToken, adjustmentId, } = props;
  return async (dispatch) => {
    try {
      const response = await axios({
        method: "POST",
        headers: {
          authorization: "Bearer " + accessToken,
          "Access-Control-Allow-Origin": "*",
        },
        url: `${Payout_Service}/reports/delete/partner-misc-adjustment?adjustmentId=${adjustmentId}`,
       
      });
      const data = response.data;
      console.log("Delete Miscellaneous Data:", data);

      // Refresh miscellaneous list after editing report
    //   await dispatch(
    //     miscellaneousListSuccess({ accessToken, financialYear })
    //   );

      return response;
    } catch (error) {
      console.error("Error:", error);
      // dispatch({
      //   type: MiscellaneousAction.GENERATE_MISCELLANEOUS_ERROR,
      //   payload: error.message || "Failed to edit miscellaneous report",
      // });
      return error;
    }
  };
}

